
    import React from 'react';
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
    import SpriteSymbolComponent from "../../components/Svg/Icon.js";
    
    const symbol = new SpriteSymbol({
  "id": "gradient-green-horizontal--sprite",
  "use": "gradient-green-horizontal--sprite-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"gradient-green-horizontal--sprite\"><defs><linearGradient id=\"gradient-green-horizontal--sprite_gradient-green-horizontal_svg__gradient\"><stop stop-color=\"#4AC1E0\" /><stop stop-color=\"#6BC049\" offset=\"100%\" /></linearGradient></defs></symbol>"
});
    sprite.add(symbol);

    export default class GradientGreenHorizontalSpriteSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="gradient-green-horizontal--sprite" viewBox="undefined" {...this.props} />;
      }
    }
  